<template>
  <div id="void-modal"
       class="modal fade"
       tabindex="-1"
       role="dialog"
       aria-labelledby="void-modal-label"
       aria-hidden="true">
    <div class="modal-dialog custom-modal">
      <div class="modal-content">
        <div class="modal-header custom-modal-header px-i">
          <div class="custom-modal-header-start">
            <h4 class="modal-title custom-modal-header-start-title">
              Void Invoice <b>{{ merchantInvoiceNumber }}</b>
            </h4>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body px-i void-invoice-text">
          After voiding the invoice, the invoice number will remain and cannot be reused. <br>

          You can delete a Void invoice to reuse its number.<br>

          <template v-if="customerInfo && customerInfo['customer_email']">
            <b> {{ customerInfo['customer_display_name'] }} </b> will receive a notification that this invoice is now VOID.
          </template>
        </div>
        <div class="modal-footer custom-modal-footer custom-modal-footer-wrap px-i">
          <button type="button"
                  data-dismiss="modal"
                  class="btn btn-outline-primary ihjoz-button ihjoz-button-mobile-stacked">
            Cancel
          </button>
          <button type="button"
                  class="btn btn-primary ihjoz-button ihjoz-button-mobile-stacked"
                  @click="voidInvoice($event)">
            Confirm Void
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoidInvoiceModal",

  props: {
    merchantInvoiceNumber: { type: String },
    customerInfo: { type: Object }
  },

  methods: {
    voidInvoice (e) {
      $("#void-modal").modal("hide");
      this.$emit("voidInvoice", e);
      e.preventDefault();
    }
  }
};
</script>
